import {
  BodyLG,
  BodyLGB,
  BodyMD,
  BodyXL,
  Heading2XL,
  Heading3XL,
  Heading4XL,
} from "../../../typography";

import { Link } from "react-router-dom";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";

export const DMESection = () => (
  <div className="tw-flex tw-flex-col tw-bg-[#33ADFF]">
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-[2em] tw-rounded-t-[4em] tw-bg-white tw-px-[1.25em] tw-pt-[5em] tw-text-center">
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-[1em]">
        <Heading3XL className="tw-my-0 tw-hidden tw-max-w-[872px] tw-text-blue-dark-3 min440:tw-flex">
          Verse is a fully accredited Durable Medical Equipment (DME) supplier
        </Heading3XL>
        <Heading2XL className="tw-my-0 tw-text-blue-dark-3 min440:tw-hidden">
          Verse is a fully accredited Durable Medical Equipment (DME) supplier
        </Heading2XL>
        <BodyXL className="tw-my-0 tw-hidden tw-max-w-[872px] tw-text-gray-2 min440:tw-flex">
          We're not just a software platform. As a CMS accredited DME supplier,
          we're able to bill for and manage the delivery of the supplies. When
          something goes wrong with an order, Verse will fully manage the
          situation, not just route your concern to another vendor.
        </BodyXL>
        <BodyLG className="tw-my-0 tw-text-gray-2 min440:tw-hidden">
          We're not just a software platform. As a CMS accredited DME supplier,
          we're able to bill for and manage the delivery of the supplies. When
          something goes wrong with an order, Verse will fully manage the
          situation, not just route your concern to another vendor.
        </BodyLG>
      </div>
      <Link to="/contact">
        <StandardButton
          style="primary-blue"
          onClick={() => {}}
          className="tw-z-40 tw-rounded-full tw-p-[1em] tw-px-[4em] tw-text-[16px]"
        >
          <BodyLGB className="tw-mb-0 tw-hidden tw-text-white min440:tw-flex">
            Get a demo
          </BodyLGB>
          <BodyMD className="tw-mb-0 tw-text-white min440:tw-hidden">
            Get a demo
          </BodyMD>
        </StandardButton>
      </Link>
    </div>
    <div className="tw-bg-white tw-py-[2em]" />
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-[1em] tw-bg-white tw-pb-[5em]">
      <Heading4XL className="tw-z-20 tw-my-0 tw-hidden tw-text-center tw-text-blue-dark-3 min440:tw-flex">
        Completely free
      </Heading4XL>
      <Heading3XL className="tw-z-20 tw-my-0 tw-text-center tw-text-blue-dark-3 min440:tw-hidden">
        Completely free
      </Heading3XL>
      <BodyXL className="tw-z-20 tw-my-0 tw-hidden tw-text-center tw-text-gray-2 min440:tw-flex">
        One of the best parts: Verse doesn't cost providers anything.
      </BodyXL>
      <BodyLG className="tw-z-20 tw-my-0 tw-w-4/5 tw-text-center tw-text-gray-2 min440:tw-hidden">
        One of the best parts: Verse doesn't cost providers anything.
      </BodyLG>
    </div>
  </div>
);
